<template>
  <td class="table-time-cell">
    <ux-icon icon="far fa-clock" /> {{ formatted }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";
import { DateTime } from "luxon";

export default {
  mixins: [TableCellMixin],
  computed: {
    formatted() {
      return this.$sdk.date.readableTime(this.value);
    },
  },
};
</script>

<style scoped lang="scss">
td {
  text-align: center;
}
</style>
